export const kpiDataTypes = [
  ['1', 'number'],
  ['2', 'percentage'],
  ['3', 'currency'],
];
export const KPI_DATA_ROW_START_INDEX = 2;
